import { render, staticRenderFns } from "./EduLearnCenter.vue?vue&type=template&id=5680068d&scoped=true&"
import script from "./EduLearnCenter.vue?vue&type=script&lang=js&"
export * from "./EduLearnCenter.vue?vue&type=script&lang=js&"
import style0 from "./EduLearnCenter.vue?vue&type=style&index=0&id=5680068d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680068d",
  null
  
)

export default component.exports